export enum FeatureToggle {
  customersAndOrdersView = 'rt_cx_admin_migration_homepage',
  customersAndOrdersCustomerDetailView = 'rt_cx_admin_migration_customer_detail',
}
